import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { noop } from '@lux/helpers';

import { BodySecondary, H3 } from '../Base';
import Button from '../Button';

import IconDiscount from '../../assets/svgs/discount.svg';

const StyledSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${p => p.theme.spacing(3)} ${p => p.theme.spacing(2)};
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);
`;

const StyledPrice = styled.div`
  display: flex;
  align-items: center;
`;

const StyledIndicativePrice = styled(H3)`
  display: inline-block;
  margin-right: ${p => p.theme.spacing(1)};
`;

const StyledOriginalPrice = styled(BodySecondary)`
  display: inline-block;
  text-decoration: line-through;
`;

const StyledIconDiscount = styled(IconDiscount)`
  margin-right: ${p => p.theme.spacing(1)};
  vertical-align: middle;
`;

const StyledOriginalPriceText = styled(BodySecondary)`
  display: inline-block;
  color: ${p => p.theme.colours.primaryVariant};
  text-transform: uppercase;
`;

const CheckoutSection = props => {
  const {
    indicativePrice,
    originalPrice,
    originalPriceText,
    onCheckout
  } = props;

  return (
    <StyledSection>
      <div>
        <StyledPrice>
          <StyledIndicativePrice>{indicativePrice}</StyledIndicativePrice>
          {originalPrice && (
            <StyledOriginalPrice>{originalPrice}</StyledOriginalPrice>
          )}
        </StyledPrice>
        {originalPriceText && (
          <Fragment>
            <StyledIconDiscount />
            <StyledOriginalPriceText>
              {originalPriceText}
            </StyledOriginalPriceText>
          </Fragment>
        )}
      </div>
      <div>
        <Button onClick={onCheckout}>Checkout</Button>
      </div>
    </StyledSection>
  );
};

CheckoutSection.defaultProps = {
  onCheckout: noop
};

CheckoutSection.propTypes = {
  indicativePrice: PropTypes.string,
  onCheckout: PropTypes.func,
  originalPrice: PropTypes.string,
  originalPriceText: PropTypes.string
};

export default CheckoutSection;
